import { render } from "./VendorMaster.vue?vue&type=template&id=62cd1eae&scoped=true"
import script from "./VendorMaster.vue?vue&type=script&lang=js"
export * from "./VendorMaster.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./VendorMaster.vue?vue&type=style&index=1&id=62cd1eae&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cd1eae"]])

export default __exports__